import {
  BadgeCheck,
  Calculator,
  CalendarDays,
  Droplet,
  FileText,
  Layers,
  LayoutTemplate,
  PenLine,
  Printer,
  Scale,
  ShoppingBag,
  Shuffle,
  Tag,
  Thermometer,
  Wrench,
} from "lucide-react";
import type { Bonus } from "../types/product";

export const bonuses: Bonus[] = [
  {
    number: 1,
    name: "Il Metodo Belnestore",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/b31c88c3-d842-4f5a-bac7-5e42ec41c90f.jpg",
    benefits: [
      { icon: Layers, lead: "Tutte le 10 categorie:", text: "come sono costruiti davvero burri, scrub, lozioni, sieri e balsami" },
      { icon: Thermometer, lead: "Conservanti e pH, spiegati semplici:", text: "quando serve un conservante, quale e quanto" },
      { icon: Wrench, lead: "Problemi e glossario:", text: "perché un lotto si separa o si indurisce e come rimediare" },
    ],
  },
  {
    number: 2,
    name: "Vendi i tuoi cosmetici",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/7df2f17c-f69b-446c-9dd6-b5307be7bea4.jpg",
    benefits: [
      { icon: Tag, lead: "Prezzo con sicurezza:", text: "il costo reale del lotto, poi quanto chiedere" },
      { icon: FileText, lead: "Modelli di etichetta:", text: "layout pronti, liste INCI e cosa puoi dire per legge" },
      { icon: ShoppingBag, lead: "Vendi nel modo giusto:", text: "da dove iniziare e come presentare le prime venti unità" },
    ],
  },
  {
    number: 3,
    name: "La guida alle sostituzioni",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/0287e904-1163-4fc1-a4fb-26f2030b5bbb.jpg",
    benefits: [
      { icon: Shuffle, lead: "Sostituisci per funzione:", text: "cosa fa ogni olio, burro ed emulsionante, così scambi like con like" },
      { icon: Scale, lead: "Resta sui 100 g:", text: "cambia qualsiasi ingrediente senza rompere le percentuali" },
      { icon: Droplet, lead: "Oli, burri e attivi:", text: "alternative sicure per ogni famiglia di ingredienti" },
    ],
  },
  {
    number: 4,
    name: "Il quaderno e planner della creatrice",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/0b31ff7a-6eae-4c9b-a3c2-4213771a1b77.jpg",
    benefits: [
      { icon: Printer, lead: "Stampa e compila:", text: "scheda formula, registro lotti e checklist qualità" },
      { icon: Calculator, lead: "Registro lotti e costi:", text: "quanto ti costa davvero ogni lotto, scritto nero su bianco" },
      { icon: CalendarDays, lead: "Pianifica e tieni traccia:", text: "scorte, scadenze e ordini" },
    ],
  },
  {
    number: 5,
    name: "Kit etichette e confezioni",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/def000d6-5417-4996-a24d-095b1fa82ecd.jpg",
    benefits: [
      { icon: BadgeCheck, lead: "Etichette conformi:", text: "codice lotto, simbolo PAO e le regole che stanno dietro" },
      { icon: PenLine, lead: "Scrivi la tua lista INCI:", text: "trasforma l'elenco ingredienti in un'etichetta vera" },
      { icon: LayoutTemplate, lead: "Modelli inclusi:", text: "layout di etichette e il packaging giusto per ogni prodotto" },
    ],
  },
];
